import { render, staticRenderFns } from "./InvenaInNumbers.vue?vue&type=template&id=e9b71eb8&"
import script from "./InvenaInNumbers.vue?vue&type=script&lang=js&"
export * from "./InvenaInNumbers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports